var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-container"},[_c('div',{staticClass:"zone-group"},[_c('div',{staticClass:"zone-rest-outline"},[_c('img',{staticClass:"zone-layout",class:{
          greenBackground: _vm.zones[0].is_occupied,
          yellowBackground: _vm.zones[0].is_maintenance,
        },attrs:{"src":require("../assets/LayoutEuroparcs/zone-europarcs.png"),"alt":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }